import { React, PT, connect, withRouter } from '@gasbuddy/react';
import { Dimmer, Loader, Segment, Dropdown, Input, Button } from 'semantic-ui-react';
import qs from 'querystring';
import moment from 'moment';
import { Action } from '../../reducers';
import { Auth, Nav, UserRequestTable } from '../../components';

function defaultStateForProps({ location, match }) {
  const { query: queryargs = {} } = qs.parse(location.search.substring(1));
  if (!queryargs && !match) {
    return {
      index: moment().utc().format('YYYY.MM.DD'),
      text: '',
      type: 'correlationId',
    };
  }
  const { index, text, start, type } = (match && match.params) || {};
  const { duration } = queryargs || {};

  return {
    type: type || 'correlationId',
    index: index || moment().utc().format('YYYY.MM.DD'),
    text: text ? decodeURIComponent(text) : '',
    start,
    duration,
    query: queryargs.query || undefined,
  };
}

class BaseLogPage extends React.Component {
  state = defaultStateForProps(this.props)

  componentDidMount() {
    this.textInput.focus();
    const { text, type } = this.state;
    if (text || (type === 'query' && this.query)) {
      this.doSearch();
    }
  }

  setStateField(field) {
    return (_, { value }) => {
      const stateChange = { [field]: value };
      if (field === 'type') {
        stateChange.text = '';
      }
      this.setState(stateChange);
    };
  }

  setStartDate = (date) => {
    this.setState({ start: date.toISOString() });
  }

  startDetailLoad = (correlationId) => {
    const { logs, dispatch } = this.props;
    if (logs.details && logs.details[correlationId]) {
      dispatch({
        type: Action.System.Logs.ForgetDetails,
        payload: correlationId,
      });
    } else {
      dispatch({
        type: Action.System.Logs.DetailRequested,
        meta: { apiAction: true },
        payload: {
          url: '/system/logs',
          body: { correlationId },
        },
      });
    }
  }

  search = () => {
    const { type, start, duration, text, query, index } = this.state;
    const { history } = this.props;
    const base = `/system/logs/${type}/${encodeURIComponent(index)}`;
    const querystring = { query };

    if (type === 'accountId') {
      querystring.duration = duration;
      history.push(`${base}/${Number(text)}/${start.toISOString()}?${qs.stringify(querystring)}`);
    } else if (type === 'correlationId') {
      history.push(`${base}/${encodeURIComponent(text)}?${qs.stringify(querystring)}`);
    } else if (type === 'query') {
      history.push(`${base}?${qs.stringify(querystring)}`);
    }
    this.doSearch();
  }

  doSearch() {
    const { dispatch } = this.props;
    const { type } = this.state;
    dispatch({
      type: Action.System.Logs.LoadRequested,
      meta: { apiAction: true },
      payload: {
        url: '/system/logs',
        body: {
          ...this.state,
          fetchRequest: type === 'correlationId',
        },
      },
    });
  }

  render() {
    const { logs: { loading, rows, details } } = this.props;
    const { type, text, index } = this.state;

    const options = [
      { key: 'corr', value: 'correlationId', text: 'Correlation Id', width: 300 },
      { key: 'acc', value: 'accountId', text: 'Account Id', width: 100 },
      { key: 'query', value: 'query', text: 'Lucene Query', width: 650 },
    ];

    const selectedType = options[options.findIndex(f => f.value === type)];

    return (
      <Auth forRoles="admin.superuser,admin.system">
        <Nav>
          <div>
            <h1>System Logs</h1>
            <Segment>
              <Input
                onChange={this.setStateField('index')}
                defaultValue={index}
                label="applogs*"
              />
              <div style={{ width: '120px', display: 'inline-block', marginLeft: 10 }}>
                <Dropdown
                  inline
                  options={options}
                  defaultValue={type}
                  onChange={this.setStateField('type')}
                />
              </div>
              <Input
                onChange={this.setStateField('text')}
                style={{ width: selectedType.width }}
                ref={(input) => { this.textInput = input; }}
                value={decodeURIComponent(text)}
              />
              {(type !== 'query')
                && (
                <div style={{ display: 'inline', marginLeft: 10 }}>
                  <Input
                    style={{ minWidth: 300 }}
                    onChange={this.setExtra}
                    placeholder="Additional Lucene-format query"
                  />
                </div>
                )
              }
              <div style={{ textAlign: 'right', marginTop: 5 }}>
                <Button primary onClick={this.search}>Search</Button>
              </div>
            </Segment>
            {(loading || rows)
              && (
              <Dimmer.Dimmable as={Segment} dimmed={loading}>
                <Dimmer active={loading}>
                  <Loader />
                </Dimmer>

                <UserRequestTable rows={rows} details={details} onSelected={this.startDetailLoad} />
              </Dimmer.Dimmable>
              )
            }
          </div>
        </Nav>
      </Auth>
    );
  }
}

BaseLogPage.propTypes = {
  dispatch: PT.func.isRequired,
  history: PT.shape({ push: PT.func.isRequired }).isRequired,
  // TODO reducer states should have their own prop-types
  logs: PT.shape({
    loading: PT.bool,
    // eslint-disable-next-line react/forbid-prop-types
    details: PT.object,
    rows: PT.arrayOf(PT.shape({

    })),
  }).isRequired,
};

export const Logs = withRouter(connect(({ logs }) => ({ logs }))(BaseLogPage));
